import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { PipelineService } from './services/pipeline.service';
import { CategoryService, RevenueTypeService } from './services';

export function provideCoreSettingsDataAccess(): EnvironmentProviders {
  return makeEnvironmentProviders([
    CategoryService,
    PipelineService,
    RevenueTypeService,
  ]);
}
